import { createFileRoute } from '@tanstack/react-router'
import ConceptCategorization from 'Concept/components/Concept/Sections/ConceptCategorization'

export const Route = createFileRoute('/concept/$conceptId/categorization')({
    component: ConceptCategorization,
})
